import { create } from "zustand"

interface PanelState {
  type: string
  data: Record<string, unknown>
}

export type PendingAction =
  | "csv_import"
  | "statement_import"
  | "new_goal"
  | "log_contribution"
  | "add_fd"
  | "add_debt"
  | "export_transactions"
  | "set_budget"
  | "add_transaction"
  | null

interface UIStore {
  sidebarCollapsed: boolean
  toggleSidebarCollapsed: () => void

  panel: PanelState | null
  openPanel: (type: string, data?: Record<string, unknown>) => void
  closePanel: () => void

  period: "3M" | "6M" | "1Y" | "All"
  setPeriod: (period: "3M" | "6M" | "1Y" | "All") => void

  commandPaletteOpen: boolean
  openCommandPalette: () => void
  closeCommandPalette: () => void

  pendingAction: PendingAction
  setPendingAction: (action: PendingAction) => void

  // A file (and its share metadata) handed off from the PWA share_target
  // landing route to whichever import flow can use it (currently CSV import).
  sharedFile: File | null
  setSharedFile: (file: File | null) => void
}

export const useUIStore = create<UIStore>((set) => ({
  sidebarCollapsed: localStorage.getItem("sidebar-collapsed") === "true",
  toggleSidebarCollapsed: () =>
    set((s) => {
      const next = !s.sidebarCollapsed
      localStorage.setItem("sidebar-collapsed", String(next))
      return { sidebarCollapsed: next }
    }),

  panel: null,
  openPanel: (type, data = {}) => set({ panel: { type, data } }),
  closePanel: () => set({ panel: null }),

  period: "6M",
  setPeriod: (period) => set({ period }),

  commandPaletteOpen: false,
  openCommandPalette: () => set({ commandPaletteOpen: true }),
  closeCommandPalette: () => set({ commandPaletteOpen: false }),

  pendingAction: null,
  setPendingAction: (action) => set({ pendingAction: action }),

  sharedFile: null,
  setSharedFile: (file) => set({ sharedFile: file }),
}))
